(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7447],{

/***/ 69492:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magnets-tech-tests",
      function () {
        return __webpack_require__(53706);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ magnets_tech_tests; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod = __webpack_require__(33161);
// EXTERNAL MODULE: ./components/form/FormSelect/index.ts + 1 modules
var FormSelect = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/form/FormText/FormText.tsx
var FormText = __webpack_require__(78712);
// EXTERNAL MODULE: ./components/HashAnchor/index.ts + 2 modules
var HashAnchor = __webpack_require__(40176);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./components/shared/Checkbox.tsx
var Checkbox = __webpack_require__(68341);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./services/service.lead.ts
var service_lead = __webpack_require__(67075);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/magnets/tech-tests/MagnetTechTestsPage.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-size: 25%;\n  padding-bottom: 200px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: -6rem auto 0 auto;\n  padding: 2rem;\n  line-height: 1.5;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: 0 auto;\n  flex: 1 1 auto;\n  padding: 4rem 2rem 2rem 2rem;\n  display: flex;\n  gap: 4rem;\n\n  .success,\n  .form {\n    flex: 1 1 55%;\n  }\n\n  .success {\n    color: #837e93;\n    text-align: center;\n    width: 85%;\n    align-self: flex-end;\n\n    h2 {\n      line-height: 1.2;\n      margin: 0;\n    }\n\n    p {\n      color: #333;\n    }\n\n    svg {\n      color: #78d549;\n    }\n  }\n\n  .content {\n    > .wrapper {\n      background: url('/images/magnets-tech-tests-bg.webp') no-repeat 0 100%;\n      background-size: 100%;\n      padding-bottom: 300px;\n    }\n\n    flex: 1 1 45%;\n\n    h2 {\n      line-height: 1.2;\n      margin: 0;\n    }\n\n    p {\n      margin-top: 0;\n    }\n  }\n\n  @media (max-width: 768px) {\n    background: none;\n    flex-direction: column;\n\n    .form,\n    .content {\n      flex: 0 0 auto;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledWrapperBG = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10174474-0"
})(_templateObject());
var StyledMktText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10174474-1"
})(_templateObject1(), (0,theme/* container */.nC)("md"));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10174474-2"
})(_templateObject2(), (0,theme/* container */.nC)("xl"));

// EXTERNAL MODULE: ../utils/dist/esm/index.js + 3 modules
var esm = __webpack_require__(74679);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./features/magnets/tech-tests/MagnetTechTestsPage.types.ts


var MagnetTechTestsFormSchema = lib.z.object({
    reason: lib.z.string(),
    fullName: lib.z.string().nonempty("common:required-message").min(2, "common:form.min-length-2"),
    email: lib.z.string().nonempty("common:required-message").min(2, "common:form.min-length-2"),
    company: lib.z.string().nonempty("common:required-message").min(2, "common:form.min-length-2")
}).refine(function(schema) {
    var ref;
    return (ref = schema.email) === null || ref === void 0 ? void 0 : ref.match(esm/* EMAIL_REGEX */.CU);
}, {
    path: [
        "email"
    ],
    message: "common:form.invalid-email"
});

;// CONCATENATED MODULE: ./features/magnets/tech-tests/MagnetTechTestsPage.tsx


























var MagnetTechTestsPage = function() {
    var t = (0,useI18n/* useI18n */.Q)("magnets").t;
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var ref = (0,react.useState)(false), isSubmitted = ref[0], setIsSubmitted = ref[1];
    var ref1 = (0,react.useState)(false), terms = ref1[0], setTerms = ref1[1];
    var ref2 = (0,react.useState)(false), accept = ref2[0], setAccept = ref2[1];
    var formMethods = (0,index_esm/* useForm */.cI)({
        mode: "onBlur",
        defaultValues: {
            fullName: "",
            email: "",
            company: ""
        },
        resolver: (0,zod/* zodResolver */.F)(MagnetTechTestsFormSchema)
    });
    var reason = formMethods.watch("reason");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    service_lead/* ServiceLead.create */.W.create({
                        clientName: data.fullName,
                        contactEmail: data.email,
                        companyName: data.company,
                        landingName: "magnets-technical-interviews",
                        isMql: data.reason === "1" || data.reason === "2",
                        createPipedriveLead: true,
                        isSubscribeToNewsletter: true
                    });
                    setIsSubmitted(true);
                } catch (ex) {
                    console.error("[MagnetTechTestsPage] Could not send form data. ".concat(ex));
                    addErrorToast(t("magnets.tech-tests.form.submit-error", {
                        error: (0,errors/* getErrorMessage */.e)(ex)
                    }));
                }
                return [
                    2
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addErrorToast,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        pageVariant: "midnight_light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapperBG, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                            direction: "column",
                            gap: "s",
                            className: "content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                gap: "s",
                                className: "wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xv, {
                                        bold: true,
                                        uppercase: true,
                                        size: "s",
                                        children: t("magnets.tech-tests.content.sub-title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                        as: "h2",
                                        size: "4xl",
                                        children: t("magnets.tech-tests.content.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "magnets",
                                        i18nKey: "magnets.tech-tests.content.desc"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                            className: "form",
                            children: !isSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                                        name: "form"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        onSubmit: formMethods.handleSubmit(onSubmit),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                            direction: "column",
                                            gap: "4xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "fullName",
                                                    formGroup: {
                                                        label: t("magnets.tech-tests.form.full-name.label")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "email",
                                                    formGroup: {
                                                        label: t("magnets.tech-tests.form.email.label")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "company",
                                                    formGroup: {
                                                        label: t("magnets.tech-tests.form.company.label")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* FormSelect */.i, {
                                                    name: "reason",
                                                    formGroup: {
                                                        label: t("magnets.tech-tests.form.reason")
                                                    },
                                                    options: [
                                                        {
                                                            label: t("magnets.tech-tests.form.reason0"),
                                                            value: "0"
                                                        },
                                                        {
                                                            label: t("magnets.tech-tests.form.reason1"),
                                                            value: "1"
                                                        },
                                                        {
                                                            label: t("magnets.tech-tests.form.reason2"),
                                                            value: "2"
                                                        },
                                                        {
                                                            label: t("magnets.tech-tests.form.reason3"),
                                                            value: "3"
                                                        },
                                                        {
                                                            label: t("magnets.tech-tests.form.reason4"),
                                                            value: "4"
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: "accept",
                                                    checked: accept,
                                                    onChange: function() {
                                                        return setAccept(function(prev) {
                                                            return !prev;
                                                        });
                                                    },
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "magnets",
                                                        i18nKey: "magnets.tech-tests.form.privacy.label"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: "terms",
                                                    checked: terms,
                                                    onChange: function() {
                                                        return setTerms(function(prev) {
                                                            return !prev;
                                                        });
                                                    },
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "magnets",
                                                        i18nKey: "magnets.tech-tests.form.terms.label",
                                                        components: {
                                                            termsLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse),
                                                                target: "_blank"
                                                            }),
                                                            privacyLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy),
                                                                target: "_blank"
                                                            })
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "none"
                                                    },
                                                    children: [
                                                        formMethods.formState.isValid ? "valid: true" : "valid: false",
                                                        terms ? "terms: true" : "terms: false"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                                        label: t("magnets.tech-tests.form.submit"),
                                                        schema: "brand2",
                                                        startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                                                        size: "xs",
                                                        isLoading: formMethods.formState.isSubmitting,
                                                        disabled: !terms || !accept || !formMethods.formState.isValid || reason === "0"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                className: "success",
                                alignment: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                        icon: pro_light_svg_icons/* faCheckCircle */.f8k,
                                        size: "6xl"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                        as: "h2",
                                        size: "2xl",
                                        children: t("magnets.tech-tests.success.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xv, {
                                        bold: true,
                                        size: "l",
                                        children: t("magnets.tech-tests.success.sub-title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "magnets",
                                        i18nKey: "magnets.tech-tests.success.desc",
                                        components: {
                                            teamLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:team@getmanfred.com",
                                                target: "_blank"
                                            })
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMktText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xv, {
                        bold: true,
                        uppercase: true,
                        size: "s",
                        children: t("magnets.tech-tests.content.sub-title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                        as: "h2",
                        size: "2xl",
                        children: t("magnets.tech-tests.mkt.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "magnets",
                            i18nKey: "magnets.tech-tests.mkt.desc"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                        to: "form",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                            label: t("magnets.tech-tests.form.submit"),
                            schema: "brand2",
                            variant: "hard",
                            startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                            size: "xs"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/magnets/tech-tests/index.ts


// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./pages/magnets-tech-tests.tsx







var MangetsTechTestsPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("magnets").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                url: app_urls/* APP_URLS.magnetsTechTests */.uu.magnetsTechTests,
                title: t("magnets.tech-tests.page-title"),
                desc: t("magnets.tech-tests.page-description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_magnets_tech-tests.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnetTechTestsPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var magnets_tech_tests = (MangetsTechTestsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3955,9161,9092,818,9774,2888,179], function() { return __webpack_exec__(69492); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);